import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getTwGuideList, getTwGuideDetail, deleteTwGuide } from '../../api/senaApi';
import { heroPortrait, skillImg as senaSkillImg } from './senaAssets';
import './SenaSiege.css';
import './SenaTotalWar.css';

const FORMATION_LABELS = {
  basic: '기본진형', balance: '밸런스진형', defense: '방어진형', protect: '보호진형',
};

const skillImg = (heroNm, skillNo) => senaSkillImg(heroNm, 'ALLY', skillNo);
const portraitImg = (heroNm) => heroPortrait(heroNm, 'ALLY');

export default function SenaTotalWar() {
  const navigate = useNavigate();
  const [guides, setGuides] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedGuide, setSelectedGuide] = useState(null);

  useEffect(() => {
    setLoading(true);
    getTwGuideList()
      .then(r => setGuides(r.data || []))
      .catch(() => setGuides([]))
      .finally(() => setLoading(false));
  }, []);

  const handleSelectGuide = async (twGuideId) => {
    try {
      const res = await getTwGuideDetail(twGuideId);
      setSelectedGuide(res.data);
    } catch { alert('공략을 불러올 수 없습니다.'); }
  };

  const handleDelete = (twGuideId) => {
    if (!window.confirm('삭제하시겠습니까?')) return;
    deleteTwGuide(twGuideId).then(() => {
      setGuides(prev => prev.filter(g => g.twGuideId !== twGuideId));
      if (selectedGuide?.twGuideId === twGuideId) setSelectedGuide(null);
    }).catch(() => alert('삭제 실패'));
  };

  const guideDecks = [...(selectedGuide?.decks || [])].sort((a, b) => a.deckOrder - b.deckOrder);

  return (
    <div className="sena-page">
      <header className="sena-header">
        <button className="siege-back-btn" onClick={() => navigate('/sena')}>← 메인으로</button>
        <h1 className="sena-header-guild">총력전</h1>
        <p className="sena-header-sub">덱 세팅</p>
      </header>

      <div className="tw-container">
        {selectedGuide ? (
          /* ===== 상세 보기 ===== */
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
              <button className="siege-detail-back" onClick={() => setSelectedGuide(null)}>← 목록으로</button>
              {(localStorage.getItem('userId') === selectedGuide.authorNm || localStorage.getItem('userRole') === 'ADMIN') && (
                <button className="siege-write-btn" onClick={() => navigate(`/sena/tw/write?id=${selectedGuide.twGuideId}`)}>수정</button>
              )}
            </div>
            <h2 className="siege-detail-title">{selectedGuide.title}</h2>
            <div className="siege-detail-meta">
              <span>{selectedGuide.authorDisplayNm || selectedGuide.authorNm}</span>
              <span>{new Date(selectedGuide.createdAt).toLocaleDateString()}</span>
            </div>
            {selectedGuide.description && (
              <p className="tw-guide-desc">{selectedGuide.description}</p>
            )}

            {/* 덱 목록 */}
            <div className="tw-deck-list">
              {guideDecks.length === 0 ? (
                <p className="gw-war-empty">등록된 덱이 없습니다.</p>
              ) : guideDecks.map(deck => (
                <div key={deck.twDeckId} className="tw-deck-card">
                  <div className="tw-deck-header">
                    <span className="tw-deck-order">덱 {deck.deckOrder}</span>
                    <span className="tw-deck-formation">{FORMATION_LABELS[deck.formation] || deck.formation}</span>
                  </div>

                  {/* 영웅 */}
                  <div className="tw-deck-heroes">
                    {(deck.heroes || []).map(hero => {
                      const img = portraitImg(hero.heroNm);
                      return (
                        <div key={hero.twDeckHeroId} className="tw-hero-card">
                          {img ? <img className="tw-hero-img" src={img} alt={hero.heroNm} />
                            : <div className="tw-hero-placeholder">{hero.heroNm}</div>}
                          <span className="tw-hero-name">{hero.heroNm}</span>
                          {hero.equipMemo && <span className="tw-hero-equip">{hero.equipMemo}</span>}
                        </div>
                      );
                    })}
                  </div>

                  {/* 예약스킬 */}
                  {deck.skills && deck.skills.length > 0 && (
                    <div className="tw-deck-skills">
                      <span className="tw-skills-label">예약스킬</span>
                      {deck.skills.map(sk => {
                        const img = skillImg(sk.heroNm, sk.skillNo);
                        return (
                          <div key={sk.twDeckSkillId} className="tw-skill-chip">
                            {img ? <img className="tw-skill-img" src={img} alt="" />
                              : <span>{sk.heroNm} 스킬{sk.skillNo}</span>}
                          </div>
                        );
                      })}
                    </div>
                  )}

                  {deck.description && <p className="tw-deck-desc">{deck.description}</p>}
                </div>
              ))}
            </div>
          </div>
        ) : (
          /* ===== 목록 ===== */
          <div>
            <div className="siege-list-header">
              <h2 className="siege-list-title">총력전 공략</h2>
              <div className="siege-list-actions">
                <span className="siege-list-count">{guides.length}건</span>
                <button className="siege-write-btn" onClick={() => navigate('/sena/tw/write')}>글쓰기</button>
              </div>
            </div>

            {loading ? (
              <div className="siege-empty"><p>조회 중...</p></div>
            ) : guides.length === 0 ? (
              <div className="siege-empty"><p>아직 등록된 공략이 없습니다.</p></div>
            ) : (
              <div className="siege-post-list">
                {guides.map(guide => (
                  <div key={guide.twGuideId} className="siege-post-card" style={{ cursor: 'pointer' }}>
                    <div onClick={() => handleSelectGuide(guide.twGuideId)} style={{ flex: 1 }}>
                      <strong className="siege-post-title">{guide.title}</strong>
                      <div className="siege-post-meta">
                        <span>{guide.authorDisplayNm || guide.authorNm}</span>
                        <span>{new Date(guide.createdAt).toLocaleDateString()}</span>
                      </div>
                    </div>
                    {(localStorage.getItem('userId') === guide.authorNm || localStorage.getItem('userRole') === 'ADMIN') && (
                      <button className="gw-war-del-btn" onClick={() => handleDelete(guide.twGuideId)}>삭제</button>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
